// Ticket 29: Elite API

const API_BASE = window.location.origin;

export async function fetchEliteStatus() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/elite/status`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch Elite status');
  }
  
  return res.json();
}
